import React, { useState, useEffect } from "react";
import Mensagens from "../../components/Mensagens";

export function useFetch(api, initialData, { onRejected } = {}) {
  const [isLoading, setIsLoading] = useState(false);
  const [fetchedData, setFetchedData] = useState(initialData);

  const listar = (_api, setLoaded) => {
    if (isLoading) {
      return;
    }

    setIsLoading(true);

    (_api instanceof Function ? _api : api)()
      .then(function (response) {
        setIsLoading(false);

        if (setLoaded instanceof Function) {
          setLoaded(response.data);
        } else {
          setFetchedData(response.data);
        }
      })
      .catch(function (error) {
        setIsLoading(false);
        setFetchedData(initialData);

        if (error) {
          console.log("erro: ", error.response);
        }

        const msg = error && error.response && error.response.status === 400 && error.response.data ? error.response.data : "Falha na conexão";
        if (onRejected) {
          onRejected(msg);
        } else {
          return;
          Mensagens.showErro(msg);
        }
      });
  };

  return [fetchedData, listar, isLoading, setFetchedData];
}

export function useSave(api, onSucess, { onRejected } = {}) {
  const [isSaving, setIsSaving] = useState(false);

  const save = (_api, _onSucess) => {
    if (isSaving) {
      return;
    }

    setIsSaving(true);

    const sucessCallback = _onSucess instanceof Function ? _onSucess : onSucess;

    (_api instanceof Function ? _api : api)()
      .then(function (response) {
        setIsSaving(false);

        if (sucessCallback) {
          sucessCallback(response.data);
        } else {
          Mensagens.showSucesso("Gravado com sucesso!");
        }
      })
      .catch(function (error) {
        setIsSaving(false);

        if (error && error.response && error.response.status === 403) {
          return;
        }

        if (error) {
          console.log("erro: ", error);
        }

        const msg = error && error.response && error.response.status === 400 && error.response.data ? error.response.data : "Falha na conexão";

        if (onRejected) {
          onRejected(msg);
        } else {
          Mensagens.showErro(msg);
        }
      });
  };

  return [save, isSaving];
}
